import { Alert as MuiAlert, styled } from '@mui/material';

const Alert = styled(MuiAlert)`
  width: 100%;

  margin-top: 40px;
`;

export default Alert;
